import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { HeaderComponent } from '../../components/header/header.component';
import { NavItem } from '../../models/nav-item.model';

@Component({
    selector: 'admin-layout',
    imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatMenuModule,
    HeaderComponent
],
    templateUrl: './admin.component.html',
    styleUrl: './admin.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class AdminLayoutComponent implements OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor() {
    }

        public navItems: NavItem[] = [
            { path: '/admin', title: 'Dashboard' },
            { path: '/admin/chemicals', title: 'Chemical Database',
                  children: [
                    { path: '/admin/chemicals', title: 'Chemical' },
                    { path: '/admin/chemical-categories', title: 'Chemical Categories' },
                ]
            },
            { path: '/admin/companies', title: 'Companies' },
            { path: '/admin/facilities', title: 'Facility',
                children: [
                    { path: '/admin/facilities', title: 'Facilities' },
                    { path: '/admin/facility/facility-status', title: 'Facility Status' },
                ]
            },
            { path: '/admin/users', title: 'Users' },
            { path: '/admin/billing', title: 'Billing', 
                children: [
                    { path: '/admin/billing/billingdetails', title: 'Billing Details' },
                    { path: '/admin/billing/products', title: 'Products (Years)' },
                    { path: '/admin/billing/subscriptions', title: 'Subscriptions' }
                ]
            },
            { path: '/admin/messenger', title: 'Messenger' },
            { path: '/admin/activity', title: 'Activity Log' },
        ];
        
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}